enum PopupType {
    Deal = "Deal",
    Lead = "Lead",
    LeaseComp = "LeaseComp",
    SaleComp = "SaleComp",
    TenantInMarket = "TenantInMarket",
    Property = "Property",
    Location = "Location",
}

export default PopupType;